import { IconProps, IconType } from '@pf/shared-common';

export const getNzIcon = (icon: keyof typeof IconType | undefined) => {
    if (!icon) {
        return null;
    }
    return IconMap.get(IconType[icon])?.iconType ?? null;
};

export const IconMap: Map<IconType, IconProps> = new Map<IconType, IconProps>([
    [IconType.barcode, { iconType: 'platform-base:barcode-fill-duo' }],
    [IconType.carrier, { iconType: 'platform-base:truck-fill-duo' }],
    [IconType.circleX, { iconType: 'platform-base:circle-xmark-open-fill' }],
    [IconType.close, { iconType: 'platform-base:circle-xmark-fill-duo' }],
    [IconType.clone, { iconType: 'platform-base:copy-fill-duo' }],
    [IconType.collapse, { iconType: 'platform-base:priority-high-fill-duo' }],
    [
        IconType.collapseAll,
        { iconType: 'platform-base:priority-highest-fill-duo' },
    ],
    [
        IconType.collapseTree,
        { iconType: 'platform-base:square-minus-fill-duo' },
    ],
    [IconType.contact, { iconType: 'platform-base:address-book-fill-duo' }],
    [IconType.copy, { iconType: 'platform-base:copy-fill-duo' }],
    [IconType.drag, { iconType: 'platform-base:grip-dots-vertical-fill-duo' }],
    [IconType.edit, { iconType: 'platform-base:file-pen-fill-duo' }],
    [IconType.email, { iconType: 'platform-base:envelope-fill-duo' }],
    [
        IconType.error,
        {
            iconType: 'platform-base:circle-warning-fill-duo',
            style: 'color: var(--ant-error-color)',
        },
    ],
    [IconType.expand, { iconType: 'platform-base:priority-low-fill-duo' }],
    [
        IconType.expandAll,
        { iconType: 'platform-base:priority-lowest-fill-duo' },
    ],
    [IconType.expandTree, { iconType: 'platform-base:square-plus-fill-duo' }],
    [
        IconType.export,
        { iconType: 'platform-base:box-archive-download-fill-duo' },
    ],
    [IconType.filter, { iconType: 'platform-base:bars-filter-fill-duo' }],
    [IconType.firebend, { iconType: 'platform-base:circle-key-fill-duo' }],
    [IconType.hide, { iconType: 'platform-base:eye-slash-fill-duo' }],
    [IconType.home, { iconType: 'platform-base:house-dashboard-fill-duo' }],
    [
        IconType.info,
        {
            iconType: 'platform-base:circle-info-fill-duo',
            style: 'color: var(--ant-info-color)',
        },
    ],
    [IconType.inlineMenu, { iconType: 'platform-base:dots-vertical-fill-duo' }],
    [IconType.item, { iconType: 'platform-base:box-fill-duo' }],
    [IconType.list, { iconType: 'platform-base:bullet-list-fill-duo' }],
    [IconType.load, { iconType: 'platform-base:hand-truck-fill-duo' }],
    [IconType.location, { iconType: 'platform-base:pin-fill-duo' }],
    [IconType.manage, { iconType: 'platform-base:gears-fill-duo' }],
    [IconType.menu, { iconType: 'platform-base:menu-fill-duo' }],
    [IconType.moneyCheck, { iconType: 'platform-base:money-fill-duo' }],
    [IconType.notification, { iconType: 'platform-base:bell-fill-duo' }],
    [IconType.phone, { iconType: 'platform-base:phone-fill-duo' }],
    [IconType.play, { iconType: 'platform-base:media-play-fill-duo' }],
    [IconType.plus, { iconType: 'platform-base:plus-fill-duo' }],
    [IconType.question, { iconType: 'platform-base:circle-question-fill-duo' }],
    [
        IconType.refresh,
        { iconType: 'platform-base:refresh-clockwise-fill-duo' },
    ],
    [
        IconType.reporting,
        {
            iconType: 'platform-base:chart-pie-2-fill-duo',
        },
    ],
    [IconType.route, { iconType: 'platform-base:path-fill-duo' }],
    [IconType.search, { iconType: 'platform-base:magnifier-fill-duo' }],
    [
        IconType.success,
        {
            iconType: 'platform-base:circle-check-fill-duo',
            style: 'color: var(--ant-success-color)',
        },
    ],
    [IconType.transportation, { iconType: 'platform-base:truck-fill-duo' }],
    [
        IconType.undo,
        { iconType: 'platform-base:arrow-rotate-anticlockwise-fill-duo' },
    ],
    [IconType.upload, { iconType: 'platform-base:cloud-upload-fill-duo' }],
    [IconType.user, { iconType: 'platform-base:user-fill-duo' }],
    [IconType.view, { iconType: 'platform-base:eye-fill-duo' }],
    [
        IconType.viewDetails,
        { iconType: 'platform-base:chevron-right-fill-duo' },
    ],
    [
        IconType.warning,
        {
            iconType: 'platform-base:triangle-warning-fill-duo',
            style: 'color: var(--ant-warning-color)',
        },
    ],
    [IconType.receiving, { iconType: 'platform-base:box-2-search-fill-duo' }],
    [IconType.putAway, { iconType: 'platform-base:box-cart-fill-duo' }],
    [
        IconType.picking,
        { iconType: 'platform-base:automated-logistics-fill-duo' },
    ],
    [IconType.packing, { iconType: 'platform-base:box-scale-fill-duo' }],
    [
        IconType.replenishments,
        { iconType: 'platform-base:sort-obj-top-to-bottom-fill-duo' },
    ],
    [IconType.cycleCounts, { iconType: 'platform-base:numbers-fill-duo' }],
    [IconType.exceptions, { iconType: 'platform-base:box-alert-fill-duo' }],
    [
        IconType.platformCore,
        { iconType: 'platform-base:house-settings-fill-duo' },
    ],
    [IconType.platformWms, { iconType: 'platform-base:storage-unit-fill-duo' }],
    [IconType.ltl, { iconType: 'platform-base:forklift-fill-duo' }],
    [
        IconType.addHandlingUnit,
        { iconType: 'platform-base:cart-plus-fill-duo' },
    ],
    [IconType.parts, { iconType: 'platform-base:wrench-screwdriver-fill' }],
    [IconType.uniform, { iconType: 'platform-base:chef-uniform-fill' }],
    [IconType.print, { iconType: 'platform-base:print-2-fill-duo' }],
    [
        IconType.download,
        { iconType: 'platform-base:cloud-download-2-fill-duo' },
    ],
    [IconType.truckCheck, { iconType: 'platform-base:truck-check-fill-duo' }],
    [
        IconType.scrollToTop,
        { iconType: 'platform-base:arrow-up-to-line-fill-duo' },
    ],
    [IconType.helpChat, { iconType: 'platform-base:help-chat-fill-duo' }],
    [
        IconType.documentation,
        { iconType: 'platform-base:side-profile-question-fill-duo' },
    ],
    [IconType.trash, { iconType: 'platform-base:trash-2-fill-duo' }],
]);

export interface IIconPopover {
    title: string;
    content: string;
}
